import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { useMemo } from 'react'
import { useAppSelector } from '@/redux/hooks'
import { selectActiveFieldsByActionType } from '../../selectors.ts'
import type { FieldAction } from '../../types.ts'
import { DisplayValue } from './DisplayValue.tsx'

type ChangesTableProps = {
  actionType: FieldAction
}

export default function ChangesTable({ actionType }: ChangesTableProps) {
  const activeValues = useAppSelector(
    selectActiveFieldsByActionType(actionType),
  )
  const tableBody = useMemo(
    () =>
      activeValues.map(([field, value]) => {
        return (
          <TableRow key={field.name}>
            <TableCell>{field.label}</TableCell>
            <TableCell>
              <Box>
                <DisplayValue value={value} />
              </Box>
            </TableCell>
          </TableRow>
        )
      }),
    [activeValues],
  )

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width="25%">Field</TableCell>
            <TableCell>New Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{tableBody}</TableBody>
      </Table>
    </TableContainer>
  )
}
